var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comment__top" },
    [
      _c("div", { staticClass: "comment__top-left" }, [
        _c("div", { staticClass: "comment__avatar" }, [
          _vm.comment.user.avatar_url !== null
            ? _c("img", {
                attrs: { src: _vm.comment.user.avatar_url, alt: "" }
              })
            : _c("span", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.usernameInsteadOfImage) +
                    "\n            "
                )
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "comment__top-right" }, [
        _c("div", { staticClass: "comment__top-right-inner" }, [
          _c("div", { staticClass: "comment__author" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.comment.user.username) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _vm.comment.wasEdited
            ? _c("div", {
                staticClass: "comment__edit comment__edit--show-on-mobile"
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "comment__date" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.comment.createdAt) + "\n        "
          )
        ]),
        _vm._v(" "),
        _vm.comment.wasEdited
          ? _c("div", {
              staticClass: "comment__edit comment__edit--not-for-mobile"
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.commentAnswerTo !== null
        ? _c("PointerAnswerTo", { attrs: { comment: _vm.commentAnswerTo } })
        : _vm._e(),
      _vm._v(" "),
      _c("LikeBtn", { attrs: { comment: _vm.comment, "is-mobile": false } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }